import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGetLanguage } from '@/hooks/useGetLanguage'

export const usePagePrice = () => {
  // 打开弹窗
  const { toolImg } = useGetLanguage()
  const { locale, t } = useI18n()

  const priceArr = [
    { key: '月付', text: t('price.text3') },
    { key: '季付', text: t('price.text4') },
    { key: '年付', text: t('price.text5') },
  ]
  const currentPrice = ref('月付')
  const currentPriceObj = computed(() => {
    const priceObj = {
      zh: {
        月付: {
          price1: '￥ 199',
          price2: '￥ 399',
          price3: '￥ 999',
          unit: '月',
          useMonth1: '',
          useMonth2: '1',
        },
        季付: {
          price1: '￥ 499',
          priceRebate1: '￥167/月',
          price2: '￥ 899',
          priceRebate2: '￥300 /月',
          price3: '￥ 2250',
          priceRebate3: '￥750 /月',
          unit: '季',
          useMonth1: '1',
          useMonth2: '3',
        },
        年付: {
          price1: '￥ 888',
          priceRebate1: '￥74 /月',
          price2: '￥ 1599',
          priceRebate2: '￥134 /月',
          price3: '￥ 7599',
          priceRebate3: '￥634 /月',
          unit: '年',
          useMonth1: '3',
          useMonth2: '12',
        },
      },
      en: {
        月付: {
          price1: '$ 29',
          price2: '$ 59',
          price3: '$ 149',
          unit: 'Month',
          useMonth1: '',
          useMonth2: '1',
        },
        季付: {
          price1: '$ 69',
          priceRebate1: '$23 /Month',
          price2: '$ 139',
          priceRebate2: '$47 /Month',
          price3: '$ 359',
          priceRebate3: '$120 /Month',
          unit: 'Quarter',
          useMonth1: '1',
          useMonth2: '3',
        },
        年付: {
          price1: '$ 199',
          priceRebate1: '$17 /Month',
          price2: '$ 399',
          priceRebate2: '$34 /Month',
          price3: '$ 1099',
          priceRebate3: '$92 /Month',
          unit: 'Year',
          useMonth1: '3',
          useMonth2: '12',
        },
      },
    } as { [key: string]: any } // 类型断言

    return priceObj[locale.value][currentPrice.value]
  })

  return {
    priceArr,
    currentPrice,
    currentPriceObj,
    toolImg,
    locale,
  }
}
